module.exports = __webpack_public_path__ + "img/1385018796.3e40b0d6.jpg";